module.exports = __webpack_public_path__ + "static/media/doctor_patientcall-480.165fe219.webp";